import { StatusTone } from '@/components/ui/statusTone.ts';
import { TpayVerificationStatus } from '@/features/dashboard/paymentProviders/types/TpayVerificationStatus.ts';

export const tpayVerificationStatusLabels: Record<
  TpayVerificationStatus,
  string
> = {
  [TpayVerificationStatus.NOT_REGISTERED]: 'Niezarejestrowany',
  [TpayVerificationStatus.PENDING]: 'Oczekuje na weryfikację',
  [TpayVerificationStatus.ACTIVE]: 'Aktywny',
  [TpayVerificationStatus.UNKNOWN]: 'Nieznany',
};

export const getTpayVerificationStatusLabel = (status: string): string => {
  return (
    tpayVerificationStatusLabels[status as TpayVerificationStatus] ?? status
  );
};

export const tpayVerificationStatusTones: Record<
  TpayVerificationStatus,
  StatusTone
> = {
  [TpayVerificationStatus.NOT_REGISTERED]: 'neutral',
  [TpayVerificationStatus.PENDING]: 'warning',
  [TpayVerificationStatus.ACTIVE]: 'success',
  [TpayVerificationStatus.UNKNOWN]: 'neutral',
};
